<template>
    <div>
        <div ref="content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import { INFO_WINDOW_CONFIG } from '@vue/components/google-maps/constants/mapSettings';
import GoogleMapsMixin from '@vue/mixins/google-maps';
export default {
    mixins: [GoogleMapsMixin],
    props: {
        position: {
            type: Object
        },
        zoomLevel: {
            type: Number
        },
    },

    data(){
        return {
            zoomedInOffset: -34,
            zoomedOutOffset: -10,
            infoWinfow: {}
        }
    },

    computed: {
        pixelOffsetY(){
            if(!this.zoomLevel) return -30;
            return this.zoomLevel >= 10 ? this.zoomedInOffset : this.zoomedOutOffset;
        }
    },

    mounted() {
        const { InfoWindow, Size } = this.google.maps;
        this.infoWindow = new InfoWindow(INFO_WINDOW_CONFIG);
        this.infoWindow.setOptions({
            pixelOffset: new Size(0, this.pixelOffsetY)
        });
        this.infoWindow.addListener('position_changed', () => {
            this.infoWindow.setContent(this.$refs.content);
            this.infoWindow.open(this.map);
        });
    },

    watch: {
        position(){
            if(this.position.lat) {
                this.infoWindow.setPosition({
                    lat: this.position.lat,
                    lng: this.position.lng,
                });
            } else {
                this.infoWindow.close();

            }
            
        },
        zoomLevel(){
            const { Size } = this.google.maps;
            this.infoWindow.setOptions({
                pixelOffset: new Size(0, this.pixelOffsetY)
            });
        }
    }
};
</script>
